import {
  BILLING_MODE_LOADING,
  BILLING_MODE_ERROR,

  BILLING_MODE_LIST
} from "actions/scooter/billing-mode-tariff/constants";

const initialState = {
  loading: false,
  errors: [],

  list: {
    content: []
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case BILLING_MODE_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case BILLING_MODE_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case BILLING_MODE_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/billingModeTariffReducer.js